/**
 * useGuestGoals — Manages goals for unauthenticated users via localStorage.
 */
import { Goal } from "@/types/todo";
import { useGuestGoalOperations } from "./guest-goals/useGuestGoalOperations";
import { useGuestTodoOperations } from "./guest-goals/useGuestTodoOperations";
import { useGuestSubtaskOperations } from "./guest-goals/useGuestSubtaskOperations";
import { useGuestSubSubtaskOperations } from "./guest-goals/useGuestSubSubtaskOperations";

export const useGuestGoals = () => {
  // Get the goal state and operations
  const { goals, setGoals, addGoal, deleteGoal, updateGoal } = useGuestGoalOperations();
  
  // Get the todo operations
  const { addTodo, deleteTodo, toggleTodo, updateTodoDueDate } = useGuestTodoOperations(goals, setGoals);
  
  // Get the subtask operations
  const { addSubtask, deleteSubtask, toggleSubtask, updateSubtaskDueDate, updateSubtaskText } = useGuestSubtaskOperations(goals, setGoals);
  
  // Get the sub-subtask operations
  const { addSubSubtask, deleteSubSubtask, toggleSubSubtask } = useGuestSubSubtaskOperations(goals, setGoals);

  return {
    goals,
    addGoal,
    deleteGoal,
    updateGoal,
    addTodo,
    deleteTodo,
    toggleTodo,
    updateTodo: () => Promise.resolve(), // Placeholder for guest mode
    addSubtask,
    deleteSubtask,
    toggleSubtask,
    updateSubtask: updateSubtaskText,
    addSubSubtask,
    deleteSubSubtask,
    toggleSubSubtask,
    updateTodoDueDate,
    updateSubtaskDueDate
  };
};
